module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-field",
    class: [{
      'cb-field--active': _vm.internalValue || _vm.focussed || _vm.countryCode
    }, _vm.customClass, {
      'cb-field--focus': _vm.focussed
    }, {
      'cb-field--error': !!_vm.errorMessage && !_vm.focussed
    }, {
      'cb-field--sibling': _vm.siblingError
    }, {
      'cb-field--select-alt': this.config.meta.help_text
    }]
  }, [_c('div', {
    staticClass: "cb-field__phone"
  }, [_c('div', {
    staticClass: "cb-field__num"
  }, [_c('input', {
    ref: "tel",
    staticClass: "cb-field__control",
    class: {
      'cb-field__readonly': _vm.readonly
    },
    attrs: {
      "type": "tel",
      "readonly": _vm.readonly,
      "name": _vm.name,
      "aria-disabled": _vm.readonly,
      "disabled": _vm.readonly,
      "aria-required": _vm.required,
      "id": _vm.name,
      "maxlength": _vm.maxLength,
      "autocomplete": _vm.autocompleteMapping
    },
    domProps: {
      "value": _vm.phoneNum
    },
    on: {
      "focus": function($event) {
        _vm.focussed = true
      },
      "keydown": _vm.onKeyDown,
      "input": _vm.onTelChange,
      "blur": function($event) {
        _vm.blur($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "cb-field__label",
    class: {
      'cb-field__label--s': _vm.isShort
    },
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.displayLabel))]), _vm._v(" "), (this.config.meta.help_text) ? _c('div', {
    staticClass: "cb-field__help"
  }, [
    [_c('div', {
      ref: "helpText",
      staticClass: "cb-field__trigger",
      class: {
        'active-opacity': _vm.helpTextShown
      },
      on: {
        "click": function($event) {
          _vm.showHelpText($event)
        }
      }
    }), _vm._v(" "), _c('transition', {
      attrs: {
        "name": "help-text"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.helpTextShown),
        expression: "helpTextShown"
      }],
      staticClass: "cb-field__menu"
    }, [_vm._v(_vm._s(this.config.meta.help_text))])])]
  ], 2) : _vm._e(), _vm._v(" "), (_vm.errorMessageWrapper && !_vm.focussed) ? _c('div', {
    staticClass: "cb-field__error"
  }, [_vm._v(_vm._s(_vm.errorMessageWrapper))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cb-field__ext",
    class: [{
      'cb-field__ext--active': _vm.swapControl
    }, _vm.customExtClass, {
      'cb-field__ext--after': _vm.internalValue || _vm.focussed || _vm.countryCode
    }]
  }, [_c('input', {
    ref: "countryCodeDisplay",
    staticClass: "cb-field__placeholder",
    attrs: {
      "type": "tel",
      "autocomplete": "false",
      "tabindex": "-1",
      "placeholder": _vm.focussed && _vm.getCountryCode
    },
    domProps: {
      "value": _vm.countryCode
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.countryCode),
      expression: "countryCode"
    }],
    ref: "select",
    staticClass: "cb-field__control",
    attrs: {
      "readonly": _vm.readonly,
      "name": _vm.name,
      "id": "ext",
      "aria-required": _vm.required
    },
    on: {
      "focus": function($event) {
        _vm.focusControl()
      },
      "blur": function($event) {
        _vm.blurControl()
      },
      "click": function($event) {
        _vm.focusControl()
      },
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.countryCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.onCountryChange]
    }
  }, _vm._l((_vm.allowedValues()), function(option, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": option.dial_code
      }
    }, [_vm._v(_vm._s(_vm.countryCodedisplayName(option)) + "\n        ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72eae79c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/collections/form/Phone.vue
// module id = 207
// module chunks = 1 2 3 4 5 25 29 30 31 32 66 67